import { cn } from "@/lib/utils"

/** The Norn mark: one thread drawn through three posts. */
export function NornMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden className={cn("size-5", className)}>
      <rect x="0.5" y="0.5" width="19" height="19" rx="5" className="fill-raised stroke-border" />
      <path d="M6 14.5v-9l8 9v-9" className="stroke-primary" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
